import { useEffect, useState } from "react";
import { heroSlides } from "@/mocks/home";

export default function Hero() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setActive((a) => (a + 1) % heroSlides.length);
    }, 6500);
    return () => clearInterval(t);
  }, []);

  const goto = (i: number) => setActive((i + heroSlides.length) % heroSlides.length);

  return (
    <section id="top" className="relative w-full h-[520px] md:h-[720px] lg:h-[820px] overflow-hidden">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === active ? "opacity-100" : "opacity-0"
          }`}
        >
          {slide.video ? (
            <video
              src={slide.video}
              poster={`${__BASE_PATH__}images/video-road-poster.webp`}
              className="w-full h-full object-cover object-top"
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
            />
          ) : (
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-950/70"></div>
        </div>
      ))}

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-6 md:px-16 max-w-6xl mx-auto">
          <div className="rv-fade-up max-w-2xl text-background-50" key={active}>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/90 text-background-50 dark:text-foreground-950 text-xs font-semibold tracking-widest">
              <span className="w-1.5 h-1.5 rounded-full bg-background-50"></span>
              {heroSlides[active].eyebrow}
            </span>
            <h1 className="rv-hero-title mt-6 font-heading text-4xl md:text-6xl font-bold leading-[1.1] tracking-tight">
              {heroSlides[active].id === "slide-0" ? (
                <>
                  속도 위에 펼쳐지는 <span className="whitespace-nowrap">X9 PRO</span>
                </>
              ) : heroSlides[active].id === "slide-1" ? (
                <>
                  <span>라이딩의 소리를</span>{" "}
                  <span className="block md:inline">다시 정의하다</span>
                </>
              ) : (
                heroSlides[active].title
              )}
            </h1>
            <p className="mt-5 text-base md:text-lg text-background-100/90 max-w-xl leading-relaxed">
              {heroSlides[active].subtitle}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <a
                href="#product"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector("#product")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="inline-flex w-[162px] items-center justify-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 px-4 py-3 text-sm font-semibold cursor-pointer whitespace-nowrap transition-colors"
              >
                {heroSlides[active].ctaLabel}
                <i className="ri-arrow-down-line"></i>
              </a>
              <a
                href={`${__BASE_PATH__}dealer/index.html`}
                className="inline-flex w-[162px] items-center justify-center gap-2 rounded-md border border-background-50/40 hover:border-background-50 text-background-50 px-4 py-3 text-sm font-semibold cursor-pointer whitespace-nowrap transition-colors bg-background-950/30 backdrop-blur"
              >
                <i className="ri-store-2-line"></i>
                협력업체 모집 안내
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-0 right-0 z-10 flex items-center justify-between px-6 md:px-16 max-w-6xl mx-auto">
        <div className="flex items-center gap-2">
          {heroSlides.map((s, i) => (
            <button
              key={s.id}
              type="button"
              aria-label={`슬라이드 ${i + 1}`}
              onClick={() => goto(i)}
              className={`h-1 rounded-full transition-all cursor-pointer ${
                i === active ? "w-10 bg-primary-500" : "w-5 bg-background-50/50 hover:bg-background-50/80"
              }`}
            ></button>
          ))}
        </div>
        <div className="hidden md:flex items-center gap-3">
          <button
            type="button"
            aria-label="이전 슬라이드"
            onClick={() => goto(active - 1)}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/40 text-background-50 hover:bg-background-50 hover:text-foreground-950 cursor-pointer transition-colors"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
          <button
            type="button"
            aria-label="다음 슬라이드"
            onClick={() => goto(active + 1)}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/40 text-background-50 hover:bg-background-50 hover:text-foreground-950 cursor-pointer transition-colors"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
